























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import NotificationDetails from "@/components/admin/notification/NotificationDetails.vue";
import {Notification} from "@/modules/request/Notification";
import _ from "lodash";
import NotificationRepository from "@/repositories/request/NotificationRepository";
import {User} from "front-component/modules/User";
import Tag from "@/components/miscellaneous/Tag.vue";

const components = {
    Tag,
    NotificationDetails
};

@Component({components})
export default class RequestNotificationList extends Vue {
    private notifications: Notification[] = [];
    private loadingNotification: boolean = false;

    @Prop({default: false}) private reload!: boolean;
    @Prop() private module!: string;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public user!: User;

    @Watch("reload")
    public onReloadChange(newValue: boolean): void {
        if (newValue) {
            this.getNotifications();
        }
    }

    public mounted(): void {
        this.getNotifications();
    }

    private getNotifications(): void {
        this.loadingNotification = true;
        this.notifications = [];
        const params = {
            filters: {
                right: true,
                ownerUuid: this.ownerUuid,
            },
        };
        NotificationRepository.get(params).then((data: object[]) => {
            if (data.length > 0) {
                this.notifications = data as Notification[];
                _.forEach(this.notifications, (notification: Notification) => {
                    if (notification.documentTypes.length === 0) {
                        notification.documentTypes = [""];
                    }
                });
            } else {
                this.notifications = [];
            }
            this.loadingNotification = false;
        });
    }

    private editNotification(notification: Notification | null): void {
        this.$emit("edit-notification", notification);
    }

    private deleteNotification(notificationUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteNotificationConfirmation"))
            .then(() => {
                NotificationRepository.delete({uuid: notificationUuid}).then(() => {
                    this.getNotifications();
                    this.$message({
                        message: _.invoke(this.$options.filters, "trans", "successDeleteNotification"),
                        type: "success"
                    });
                }).catch(() => {
                    this.$message({
                        message: _.invoke(this.$options.filters, "trans", "errorDeleteNotification"),
                        type: "error"
                    });
                });
            }).catch(() => {
                return;
            }
        );
    }
}
